import { $, $$, isMobile, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Scrollbar, A11y, FreeMode } from 'swiper/modules';

import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-lubes-recommender]')) return;

  const slidersArray = [];

  addEventListeners(slidersArray);
  buildSlider(slidersArray, isMobile.matches);
  lubesDatalayer();
}

function addEventListeners(slidersArray) {
  isMobile.addEventListener('change', () => {
    slidersArray.forEach((slider) => slider.destroy());
    buildSlider(slidersArray, isMobile.matches);
  });
}

function buildSlider(slidersArray, isMobile) {
  $$('[data-au-lubes-recommender-options]').forEach((slider) => {
    if (isMobile) {
      const logoSlider = new Swiper(slider, {
        modules: [Scrollbar, A11y, FreeMode],
        ...sliderConfig,
      });

      slidersArray.push(logoSlider);
    }
  });
}

function lubesDatalayer() {
  $$('[data-au-snap-card-mini]').forEach((card) => {
    card.addEventListener('click', (e) => {
      const cardText = e.currentTarget.querySelector('[data-au-snap-card-mini-title]').innerText;
      const stepTitle = e.currentTarget
        .closest('[data-au-recommender-content]')
        .querySelector('[data-au-recommender-step-title]').innerText;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id: `${removeAccentMarkAndUppercase(stepTitle)}_${removeAccentMarkAndUppercase(cardText)}`,
      });
    });
  });

  $$('[data-au-lubes-recent-card-link]').forEach((card) => {
    card.addEventListener('click', (e) => {
      const cardText = e.target.querySelector(':not([data-au-icon])').innerText;
      const stepTitle = e.currentTarget
        .closest('[data-au-recommender-content]')
        .querySelector('[data-au-recommender-step-title]').innerText;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id: `${removeAccentMarkAndUppercase(stepTitle)}_${removeAccentMarkAndUppercase(cardText)}`,
      });
    });
  });
}

export default { init };
